import { GlobalScoreLayout } from '../../shared/global-score-layout/global-score-layout';
import { ScoreCard } from '../../shared/score-card/score-card';
import { ScoreDetailsTable } from '../../shared/score-details-table/score-details-table';

export const GlobalScoreComponent: React.FC<{
  scores: number[],
  getScoreFromCheese: (score: number) => number
}> = ({ scores, getScoreFromCheese }) => {
  const totalScore = scores.reduce((total, score) => total + getScoreFromCheese(score), 0);

  return (
    <GlobalScoreLayout totalScore={Math.round(totalScore)}>
      {scores.map((score, index) => (
        <ScoreCard
          key={index}
          name={`${index + 1}${index === 0 ? 'er' : 'e'} bout de pain`}
          score={Math.round(getScoreFromCheese(score))}
        >
          <ScoreDetailsTable rows={[
            { label: 'Quantité de fromage:', value: `${Math.round(score / 100)}g` },
            { label: 'Niveau:', value: `${Math.floor(score / 1000)} (final multiplier: ${1 + Math.floor(score / 1000)})` },
          ]} />
        </ScoreCard>
      ))}
    </GlobalScoreLayout>
  );
}
